<!--
Menu to display all app items.

19/07/2022 note at the moment we need to find out if the user has deadlines/grades to display and
           hide the Deadlines and Grades menu item if they don't
           it's hard coding -- sorry
@author ab557z
-->
<template>
  <div id="contain" class="container">
    <Nav name="More"/>
      <div style="margin-left:24px;margin-right:24px;">
      <div style="margin-top:24px;margin-bottom:24px;border-radius: 16px;border:1px solid #f7f7f7;background-color:#f7f7f7;min-height:36px;width:100%;padding-left:16px;">
        <font-awesome-icon style="color:#005C8A;" icon="search" size="sm"></font-awesome-icon>
        <input v-model="filter" type="text" style="padding-left:14px;background-color:#f7f7f7;color:#005C8A;border:0px;margin-top:4px;width:90%" placeholder="Find something..." />
      </div>
  </div>

      <ul style="padding-left:0px;">
        <MenuItem v-for="(result,index) in results" :key="index" :text="result.title" :icon="result.icon" :path="result.path" />
      </ul>
     <div id="pusher"></div>
     <Footer active="menu" tab_i='5'/>
  </div>
</template>
 <!--    <h5>Level 1</h5>
<vm-progress :percentage="update" type="circle"
>Hello</vm-progress>

 <vm-progress :percentage="update" :text-inside="true" :stroke-width="18" status="info"></vm-progress>  -->

<script setup>
//Utilities
import { ref, onMounted, watch } from 'vue'
import axios from 'axios'
import $cookies from 'vue-cookies'

//Components
import Footer from '@/components/FooterMenu.vue'
import MenuItem from '@/components/MenuItem.vue'

//Data
const hasRoomBookingAccess = ref($cookies.get('hasRoomBookingAccess') === 'true')
const hasDeskBookingAccess = ref($cookies.get('hasDeskBookingAccess') === 'true')
const assessmentDataAvailable = ref(false)
const results = ref([]) /* filtered list of items */
const items = ref([]) /* total list of items */
const filter = ref('')

onMounted(() => {
  checkHasAssessmentData()
})

async function checkHasAssessmentData () {
  console.log('checking if any assessment data...')
  const response = await axios.get('/timetable/grades/hasdata', { withCredentials: true })

  const hasData = response.data
  console.log('hasData = ' + hasData)
  if (typeof hasData === 'string') {
    assessmentDataAvailable.value = (hasData == 'true')
  } else if (typeof hasData === 'boolean') {
    assessmentDataAvailable.value = hasData
  } else {
    console.log('return value is of type ' + (typeof hasData))
  }
  fetchMenu()
}

async function fetchMenu () {
  results.value = []
  items.value = []
  const response = await axios.get('/timetable/menu')
  let tempItems = response.data

  tempItems.forEach(res => {
    if (res.path == '/deadlines') {
      console.log('does the student have assessment data? ' + assessmentDataAvailable.value)
      if (assessmentDataAvailable.value) {
        items.value.push(res)
      }
    } else {
      items.value.push(res)
    }
  })

  results.value = items.value
}

function filterItem (item) {
  if (item.title.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0) {
    results.value.push(item)
  }
}

watch(filter, (newFilter) => {
  results.value = []
  items.value.forEach(filterItem)
});


</script>

<style scoped>
.menuUl {
 margin-top:0px;
}

</style>
